import {createSlice} from '@reduxjs/toolkit';
import appConfig from "../config/api";
import assetsConfig from "../config/assets";
import {setAgentId} from "../utils/user";

export const defaultWebSite = {
    logo : assetsConfig.logo,
    name : "RCS消息平台",
    title: "RCS消息平台"
}

const initialState = {
    website : defaultWebSite
};

export const appSlice = createSlice({
    name: 'app',
    initialState,
    reducers: {
        appInit: (state, action) => {
            if(action.payload) {
                let {website} = action.payload
                if (website) {
                    if (website.logo) {
                        website.logo = appConfig.baseUrl + website.logo;
                    }
                    if (website.logoSmall) {
                        website.logoSmall = appConfig.baseUrl + website.logoSmall;
                    }
                    let host = window.location.host;
                    if(!host.startsWith("system") && host.indexOf("tenant") < 0){
                        document.title = website.title;
                    }
                    document.querySelector('meta[name="description"]').setAttribute('content',website.description);
                    state.website = website;
                    setAgentId(website.agentId)
                }
            }
        }
    }
});

export const { appInit } = appSlice.actions;

export const selectWebsiteInfo = ( state ) => {
    return state.app?.website || defaultWebSite;
}

export default appSlice.reducer;
